// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page container */
.ailive-container {
  min-height: 100vh;
  width: 100%;
  background-color: #0a0f1c;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

/* Main layout */
.ailive-layout {
  width: 100%;
  max-width: 700px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Base button */
.ailive-button {
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: linear-gradient(145deg, #182344, #101833);
  color: #ffffff;
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
  padding: 30px 24px;
  transition: all 0.25s ease;
}

.ailive-button:hover {
  background: linear-gradient(145deg, #1b2a52, #121a33);
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.45);
}

.ailive-button:active {
  transform: scale(0.97);
}

/* Banner button */
.ailive-button.banner {
  width: 100%;
  font-size: 40px;
  padding: 50px;
  margin-bottom: 30px;
}

/* Bottom row */
.ailive-bottom-row {
  display: flex;
  gap: 50px;
  width: 100%;
  margin-bottom: 30px;
}

/* Comment button (bigger) */
.ailive-button.comment {
  flex: 1.3 1;
  font-size: 35px;
  padding: 50px 80px;
}

/* Final button (slightly smaller) */
.ailive-button.final {
  flex: 1 1;
  font-size: 30px;
  padding: 30px;
}

/* Tablet */
@media (max-width: 768px) {
  .ailive-button.banner {
    font-size: 18px;
    padding: 22px;
  }

  .ailive-bottom-row {
    gap: 16px;
  }
}

/* Mobile */
@media (max-width: 480px) {
  .ailive-bottom-row {
    flex-direction: column;
  }

  .ailive-button {
    width: 100%;
  }

  .ailive-button.comment,
  .ailive-button.final {
    font-size: 16px;
  }
}

.controller-loading {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.controller-loading-box {
  width: 360px;
  background: #0f172a;
  border-radius: 16px;
  padding: 24px;
  text-align: center;
  color: #fff;
}

.controller-loading-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}

.controller-loading-bar {
  width: 100%;
  height: 8px;
  background: rgba(255,255,255,0.15);
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 12px;
}

.controller-loading-fill {
  height: 100%;
  background: linear-gradient(90deg, #38bdf8, #22d3ee);
  transition: width 0.4s ease;
}

.controller-loading-text {
  font-size: 13px;
  opacity: 0.85;
}`, "",{"version":3,"sources":["webpack://./src/pages/ailiveshow/AILiveShowController.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,WAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,SAAO;EACP,eAAe;EACf,aAAa;AACf;;AAEA,WAAW;AACX;EACE;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,WAAW;AACX;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,aAAa;AACf","sourcesContent":["/* Page container */\r\n.ailive-container {\r\n  min-height: 100vh;\r\n  width: 100%;\r\n  background-color: #0a0f1c;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 24px;\r\n}\r\n\r\n/* Main layout */\r\n.ailive-layout {\r\n  width: 100%;\r\n  max-width: 700px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 24px;\r\n}\r\n\r\n/* Base button */\r\n.ailive-button {\r\n  border-radius: 16px;\r\n  border: 1px solid rgba(255, 255, 255, 0.15);\r\n  background: linear-gradient(145deg, #182344, #101833);\r\n  color: #ffffff;\r\n  font-size: 17px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  padding: 30px 24px;\r\n  transition: all 0.25s ease;\r\n}\r\n\r\n.ailive-button:hover {\r\n  background: linear-gradient(145deg, #1b2a52, #121a33);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.45);\r\n}\r\n\r\n.ailive-button:active {\r\n  transform: scale(0.97);\r\n}\r\n\r\n/* Banner button */\r\n.ailive-button.banner {\r\n  width: 100%;\r\n  font-size: 40px;\r\n  padding: 50px;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n/* Bottom row */\r\n.ailive-bottom-row {\r\n  display: flex;\r\n  gap: 50px;\r\n  width: 100%;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n/* Comment button (bigger) */\r\n.ailive-button.comment {\r\n  flex: 1.3;\r\n  font-size: 35px;\r\n  padding: 50px 80px;\r\n}\r\n\r\n/* Final button (slightly smaller) */\r\n.ailive-button.final {\r\n  flex: 1;\r\n  font-size: 30px;\r\n  padding: 30px;\r\n}\r\n\r\n/* Tablet */\r\n@media (max-width: 768px) {\r\n  .ailive-button.banner {\r\n    font-size: 18px;\r\n    padding: 22px;\r\n  }\r\n\r\n  .ailive-bottom-row {\r\n    gap: 16px;\r\n  }\r\n}\r\n\r\n/* Mobile */\r\n@media (max-width: 480px) {\r\n  .ailive-bottom-row {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .ailive-button {\r\n    width: 100%;\r\n  }\r\n\r\n  .ailive-button.comment,\r\n  .ailive-button.final {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n.controller-loading {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0,0,0,0.55);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 999;\r\n}\r\n\r\n.controller-loading-box {\r\n  width: 360px;\r\n  background: #0f172a;\r\n  border-radius: 16px;\r\n  padding: 24px;\r\n  text-align: center;\r\n  color: #fff;\r\n}\r\n\r\n.controller-loading-title {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.controller-loading-bar {\r\n  width: 100%;\r\n  height: 8px;\r\n  background: rgba(255,255,255,0.15);\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.controller-loading-fill {\r\n  height: 100%;\r\n  background: linear-gradient(90deg, #38bdf8, #22d3ee);\r\n  transition: width 0.4s ease;\r\n}\r\n\r\n.controller-loading-text {\r\n  font-size: 13px;\r\n  opacity: 0.85;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
